import { render, staticRenderFns } from "./List.vue?vue&type=template&id=c4e0bfb8&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/janpencik/Sites/events/wp-content/plugins/event-feed-for-eventbrite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4e0bfb8')) {
      api.createRecord('c4e0bfb8', component.options)
    } else {
      api.reload('c4e0bfb8', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=c4e0bfb8&", function () {
      api.rerender('c4e0bfb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/src/js/components/List.vue"
export default component.exports